import { render, staticRenderFns } from "./ThirdSection.vue?vue&type=template&id=557ea33e&scoped=true&"
var script = {}
import style0 from "./ThirdSection.vue?vue&type=style&index=0&id=557ea33e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557ea33e",
  null
  
)

export default component.exports